<template>
    <div style="background:#fff; margin-left:3px; "> 
        <div style="border-bottom:2px solid #389;display:flex;margin-top:0px">
 
            <div style="font-size:12px;margin-right:4px;margin-left:15px;line-height:30px">字段查询</div>
            <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:5px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper"  size="small" style="width:110px; ">
                <span v-for="item in operArr" :key='item.IDSEQ'>
                    <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                </span>
            </el-select>
            <el-input placeholder="请输入查询值" ref="refqry" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:260px;margin-left:2px; ">
                <el-button size="small" slot="append" icon="el-icon-search" @click.native="qryTabData" style="color:#409eff"></el-button>
            </el-input> 
 
            <el-button type="info" size="mini" icon="iconfont icon-shanchu" @click="btnExit" style=" margin-left:30px;">取消</el-button>
            <el-button type="primary" size="mini" icon="iconfont icon-yiqueren-xianxing" @click="selSure" style=" margin-left:30px;">确定</el-button>
        </div>
        <div style="width:100%">
            <ve-table :columns="vueCol" 
                    :table-data="tabData " 
                    :columnHiddenOption="columnHiddenOption"
                    style="margin-top:0px; "
                    :border-around="true"
                    :border-x="true" 
                    :border-y="true" 
                    :fixed-header="true"
                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="tabHeight" 
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                    :footer-data="footerData"
                    :column-width-resize-option="{enable: true,}"
                    :cellSelectionOption="{enable: false,}"
                    v-loading="v_loading"
                    :element-loading-text="$LANG('1959', '加载中')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    id="pub_easy_one"
                    ref="tableRef" >
            </ve-table>
            <div style="margin-top:2px">
                <ve-pagination
                    :total="dataCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageList"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
      
        </div>
 
 
        <!-- 提示框 -->
        <el-dialog :visible.sync="promptWin" v-dialogDrag width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
 
</template>
<script>
import {  getBaseData } from '../../api/user' 
import {upperJSONKey } from '../../api/Tools' 
export default {
    //props:['v_table','tabCol' ],
    props: {
        v_key2:{
            type: String,
            default:'',
        } ,
        v_value2:{
            type: String,
            default:'',
        },
        v_data:{
            type: Array,
        },
        v_table:{
            type: String,
        },
        tabCol:{
            type: Array,
        },
        v_cond:{
            type: String,
            default:'',
        },
        v_random:{
            type: Number,
        },
    },
    data () {
        return {
            oper:'like',
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'',// select 绑定值
            txtparam:'', // input 绑定值
            tabData:[] ,// 
            selAll:'N',
            operArr:[],
            v_loading:false,
            promptWin:false,
            prompt:'',   
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            v_sel:'N',
            v_row:{},
            pageList: [100,500,1000],
            dataCount:0,
            pageSize:100,
            pageIndex:1,
 
            vueCol:[],
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,                
            }, 
            startRowIndex: 0,
            footerData:[], 
            footDtl:[],
            virtualScrollOption: { enable: false },
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1"      
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            v_sort:'asc',
            v_inputrow:{},
            allList:[], //询价单集合
        }
    },
    destroyed() {
 
    },
    created () {
 
         this.getFields()
    },
    watch: {
        v_table:function(){ //侦测变量值改变时 执行此方法
            this.qryTabData()  
            this.selAll='N'
 
        } ,
        v_value2:function(){ //侦测变量值改变时 执行此方法
            this.qryTabData()  
            this.selAll='N'
 
        } ,
        v_random:function(){ //侦测变量值改变时 执行此方法
            this.qryTabData()  
            this.selAll='N'
 
        } 
    },
    mounted () {   

        //this.getFields()
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        this.qryTabData()
        this.selAll='N'

    },
    computed: {
        tabHeight() {
          return  window.innerHeight -223
        },
        scrollerHeight: function() {
            return (window.innerHeight - 80) + 'px';
        }, 
    },
    methods: { 
 
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.pageIndex =index
            this.tabData = this.allList.slice(_start,_end)
            //this.getFootSum()
        },
        initPage(){
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.pageSize){
                this.tabData = this.allList          
            }else{
                this.tabData =this.allList.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素
            }
            //this.getFootSum()
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },

        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabCol.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]  
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]     
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },
 
        //字段查询
        inputQry(){
            this.qryTabData()  
        },
 
        //下推选择记录
        selSure(){
            if (this.tabData.filter(item=>item.SEL=='Y').length==0) {
                this.promptWin =true
                this.prompt ='请选择一行记录'
            }else {
                this.v_row ={}
                this.$emit('child-sure',this.tabData.filter(item=>item.SEL=='Y'))
 
            }
        },
        btnExit(){
            this.$emit('child-exit' )
 
        },
  
        //查询表格数据
        qryTabData(){
            let cond_= this.v_cond ,v_edcss=''
            if (this.selparam && this.txtparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+' like  \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
                cond_ =cond_+' order by '+this.selparam
            }
            let v_cond ='' , v_oper='like' 
            Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (this.v_row[`#OPER`+item]){
                        v_oper =this.v_row[`#OPER`+item]
                    }
                    if (v_edcss =='number' ){
                        if (v_oper=='like'){
                            v_oper ='='
                        }
                        v_cond =v_cond +' and '+item+ v_oper +  this.v_row[item] 
                    }else if ( v_edcss=='date'){
                        if (v_oper =='like'){
                            v_cond =v_cond +' and '+item+ ' like \''+this.v_row[item] +'%\''
                        }else {
                            v_cond =v_cond +' and '+item+ v_oper +'\''+this.v_row[item] +'\''
                        }
                    }else{              
                        v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''         
                    }                   
                }
            })
            this.v_loading =true
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid', p_value:this.v_corpid,p_key2:this.v_key2,p_value2:this.v_value2,p_cond:cond_+v_cond,p_table: this.v_table},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allList =res.result 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.v_loading =false
                    })
                    this.initPage() 
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }    
            }) 
            
        },
        getFields(){
            let vm =this
            for (let k=0; k<this.tabCol.length; k++){
                let itcol =this.tabCol[k]
                vm.vueCol.push({ //向数组的开头 添加序列号
                    title: itcol.title,
                    key: itcol.key,
                    align: itcol.align,
                    width:Number(itcol.width),
                    thide:itcol.thide,
  
                    type:itcol.edcss=='checkbox'?'check':itcol.edcss,
                    disabled:itcol.disabled,
                    field:itcol['key'] ,
                    sortable:false,
                    ellipsis: { showTitle: true, },
                    renderHeaderCell: ({column}, h) => {
                   
                        if (itcol.edcss =='number') {
                            return (                              
                                <div >
                                    <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                        <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                    </div>  
                                    <div style="display:flex">
                                        <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_row[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                            <option    value="="  >=</option>
                                            <option    value=">"  >&gt;</option>
                                            <option    value="<"  >&lt;</option>
                                            <option    value="!="  >!=</option>
                                        </select>                                                 
                                        <el-input  placeholder="请输入"  disabled={itcol.EDCSS=='image'}  v-model={this.v_row[column.key]}   on-change={()=>this.inputQry() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input> 
                                    </div>
                                </div>                                   
                            )
                        }else{
                            if (itcol.EDCSS=='checkbox'){
                                return (                              
                                    <div >
                                        <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                            <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                        </div>  
                                        <div style="display:flex">
                                            <el-select size="mini" style="width:100%;background:white;height:28px;margin-top:1px" v-model={this.v_row[column.key]}   on-change={()=>{this.inputQry()}}>
                                                <el-option  value="Y" label="是" ></el-option>
                                                <el-option  value="N"  label="否" ></el-option>
                                            </el-select>                                                          
                                        </div>
                                    </div>                                   
                                )    
                            }else {
                                return (                              
                                    <div >
                                        <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                            <el-link underline={false} on-click={()=>{this.sortChange(column)} } style="font-size:12px;color:#03274b;font-weight:700; ">{column.title}</el-link>                                            
                                        </div>  
                                        <div style="display:flex">
                                            <el-input  placeholder="请输入"  disabled={itcol.EDCSS=='image'}  v-model={this.v_row[column.key]}   on-change={()=>this.inputQry() } style="padding:0px;margin-top:1px;width:100%;height:28px; " size="mini"></el-input> 
                                        </div>
                                    </div>                                   
                                )
                            }
                        }
                      
                    },
                    renderBodyCell: ({row,column,rowIndex},h) => {
                        let  rowVal =row[itcol['key'] ]
                        if (column.key=='SEL') {                         
                            return (<el-checkbox   true-label="Y" false-label="N" size="small" v-model={row[itcol['key']]}> </el-checkbox> )         
                        }else if (itcol.edcss=='image' ){
                            return ( 
                                <el-image fit="scale-down"  style="width:100%;height:30px; " src={rowVal} preview-src-list={[rowVal]}>
                                    <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                                </el-image>
                            )
                        }else if (itcol.EDCSS =='checkbox'||itcol.edcss =='checkbox'||column.key =='STFG' ) {                         
                            if (row[itcol['key']] =='Y'){
                                return (<el-tag   size="mini" type="success" effect="dark">是</el-tag> )
                            }else {
                                return (<el-tag   size="mini" type="info" effect="dark">否</el-tag> )
                            }                                          
                        }else{
                            return row[itcol['key'] ]
                        }
                    }, 
                })
            }
            let v_rownum ={
                field: "index",
                key: "rownum",
                title: "序号",
                width: 55,
                align: "center",
                fixed:"left",
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return (<span style="color:#1890ff;">
                        {rowIndex + this.startRowIndex + 1}
                    </span> )
                },
                renderHeaderCell: ({column}, h) => {
                    return (  
                        <div >
                            <div style="margin-top:3px">{column.title}</div>
                            <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                <el-tooltip content=" 清除条件" effect="light">
                                    <i class="iconfont icon-shanchu1"  ></i>
                                </el-tooltip>
                            </el-link>
                        </div>
                    )
                },
            }
            this.vueCol.unshift(v_rownum) 
 
        }
    }
}
 
</script>
<style scoped lang="less" >
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
 
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
 
</style>
